


// import React from "react";
// import CvInfo from "./CvInfo";
// import CvEducation from "./CvEducation";
// import CvWorkExperience from "./CvWorkExperience";
// import CvCertificate from "./CvCertificate";
// import CvGuarantor from "./CvGuarantor";
// import { useSelector } from "react-redux";
// import PDFGenerator from "./pdf/PDFGenerator";
// import { FaCheckCircle, FaCalendar } from 'react-icons/fa';

// function CvTemplate3({education, experience, certificate, guarantor}) {
//   const loggedInUser = useSelector(state => state.user);
//   const currentDate = new Date().toLocaleDateString('en-GB');
  
//   return (
//     <PDFGenerator>
//       <div className="min-h-[297mm] w-full max-w-[210mm] mx-auto bg-gray-50 relative overflow-hidden">
        
//         {/* Header Bar */}
//         <div className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white p-5 sm:p-6">
//           <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
//             <div className="flex items-center gap-4">
//               <h1 className="text-xl sm:text-2xl font-bold">e-Job CV</h1>
//               <button className="px-4 py-2 bg-white/20 hover:bg-white/30 rounded-lg backdrop-blur-sm flex items-center gap-2 transition-colors text-sm whitespace-nowrap">
//                 <FaCheckCircle className="text-green-300" />
//                 e-verify log
//               </button>
//             </div>
//             <div className="text-left sm:text-right">
//               <p className="text-white/80 text-sm">Date Generated</p>
//               <div className="flex items-center gap-2">
//                 <FaCalendar className="text-white/60" />
//                 <span>{currentDate}</span>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="flex flex-col lg:flex-row">
          
//           {/* Sidebar - Stack on mobile, side-by-side on large screens */}
//           <div className="w-full lg:w-1/3 bg-gradient-to-b from-purple-700 to-indigo-800 text-white min-h-[calc(297mm-4rem)] p-6 sm:p-8 lg:min-h-auto">
//             <div className="sticky top-8">
//               <div className="mb-8">
//                 <h2 className="text-2xl font-bold mb-4 leading-tight">
//                   {`${loggedInUser.currentUser.firstName} ${loggedInUser.currentUser.lastName}`}
//                 </h2>
//                 <p className="text-purple-200 text-sm">Professional Profile</p>
//               </div>

//               <div className="space-y-6">
//                 <div className="border-l-2 border-purple-400 pl-4">
//                   <CvInfo 
//                     third={true} 
//                     title="Date of Birth" 
//                     data={loggedInUser.currentUser.dateOfBirth}
//                     className="text-purple-100" 
//                   />
//                 </div>
//                 <div className="border-l-2 border-purple-400 pl-4">
//                   <CvInfo 
//                     third={true} 
//                     title="Email" 
//                     data={loggedInUser.currentUser.email}
//                     className="text-purple-100"
//                   />
//                 </div>
//                 <div className="border-l-2 border-purple-400 pl-4">
//                   <CvInfo 
//                     third={true} 
//                     title="Address" 
//                     data={loggedInUser.currentUser.address}
//                     className="text-purple-100"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Main Content */}
//           <div className="flex-1 p-6 sm:p-8 bg-white shadow-xl">
            
//             {/* Education Section */}
//             <section className="mb-10">
//               <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-6 border-b-2 border-purple-200 pb-2">
//                 Education Background
//               </h3>
//               <div className="space-y-4">
//                 {education?.map((eachEducation, index) => (
//                   <CvEducation
//                     key={index}
//                     school={eachEducation?.school}
//                     course={eachEducation?.course}
//                     year={`${eachEducation?.startYear} - ${eachEducation?.finishYear}`}
//                   />
//                 ))}
//               </div>
//             </section>

//             {/* Work Experience Section */}
//             <section className="mb-10">
//               <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-6 border-b-2 border-purple-200 pb-2">
//                 Work Experience
//               </h3>
//               <div className="space-y-6">
//                 {experience?.map((eachExperience, index) => (
//                   <CvWorkExperience
//                     key={index}
//                     title={eachExperience?.positionHeld}
//                     companyName={eachExperience?.companyName}
//                     year={`${eachExperience?.startYear} - ${eachExperience?.finishYear}`}
//                     jobDescription={eachExperience?.jobDescription}
//                   />
//                 ))}
//               </div>
//             </section>

//             {/* Certificates Section */}
//             <section className="mb-10">
//               <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-6 border-b-2 border-purple-200 pb-2">
//                 Certificates
//               </h3>
//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                 {certificate?.map((eachCertificate, index) => (
//                   <CvCertificate
//                     key={index}
//                     title={eachCertificate?.certificateName}
//                     year={eachCertificate?.issueDate}
//                     serialNumber={eachCertificate?.serialNumber}
//                   />
//                 ))}
//               </div>
//             </section>

//             {/* Guarantor Section */}
//             <section className="mb-10">
//               <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-6 border-b-2 border-purple-200 pb-2">
//                 Guarantor
//               </h3>
//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                 {guarantor?.map((eachGuarantor, index) => (
//                   <CvGuarantor
//                     key={index}
//                     guarantorName={eachGuarantor?.name}
//                     phoneNumber={eachGuarantor?.phone}
//                   />
//                 ))}
//               </div>
//             </section>
//           </div>
//         </div>
//       </div>
//     </PDFGenerator>
//   );
// }

// export default CvTemplate3;










import React, { useState, useEffect } from "react";
import CvInfo from "./CvInfo";
import CvEducation from "./CvEducation";
import CvWorkExperience from "./CvWorkExperience";
import CvCertificate from "./CvCertificate";
import CvGuarantor from "./CvGuarantor";
import { useSelector } from "react-redux";
import PDFGenerator from "./pdf/PDFGenerator";
import { FaCheckCircle, FaCalendar, FaEdit, FaSave } from 'react-icons/fa';

function CvTemplate3({ education, experience, certificate, guarantor }) {
  const loggedInUser = useSelector(state => state.user);
  const currentDate = new Date().toLocaleDateString('en-GB');

  // Local editing state
  const [isEditing, setIsEditing] = useState(false);
  const [editableData, setEditableData] = useState({
    personalInfo: {
      firstName: loggedInUser?.currentUser?.firstName || '',
      lastName: loggedInUser?.currentUser?.lastName || '',
      dateOfBirth: loggedInUser?.currentUser?.dateOfBirth || '',
      email: loggedInUser?.currentUser?.email || '',
      address: loggedInUser?.currentUser?.address || '',
    },
    education: education || [],
    experience: experience || [],
    certificate: certificate || [],
    guarantor: guarantor || [],
  });

  // Sync with props when they change
  useEffect(() => {
    setEditableData({
      personalInfo: {
        firstName: loggedInUser?.currentUser?.firstName || '',
        lastName: loggedInUser?.currentUser?.lastName || '',
        dateOfBirth: loggedInUser?.currentUser?.dateOfBirth || '',
        email: loggedInUser?.currentUser?.email || '',
        address: loggedInUser?.currentUser?.address || '',
      },
      education: education || [],
      experience: experience || [],
      certificate: certificate || [],
      guarantor: guarantor || [],
    });
  }, [loggedInUser, education, experience, certificate, guarantor]);

  // Handle personal info changes
  const handlePersonalChange = (field, value) => {
    setEditableData(prev => ({
      ...prev,
      personalInfo: {
        ...prev.personalInfo,
        [field]: value
      }
    }));
  };

  // Handle array section changes
  const handleArrayChange = (section, index, field, value) => {
    setEditableData(prev => {
      const newArray = [...prev[section]];
      newArray[index] = { ...newArray[index], [field]: value };
      return { ...prev, [section]: newArray };
    });
  };

  const toggleEdit = () => {
    if (isEditing) {
      console.log("CV Changes Saved:", editableData);
      // Dispatch to Redux here if needed
    }
    setIsEditing(!isEditing);
  };

  return (
    <PDFGenerator>
      <div className="min-h-[297mm] w-full max-w-[210mm] mx-auto bg-gray-50 relative overflow-hidden">

        {/* Floating Edit Button */}
        <button
          onClick={toggleEdit}
          className="absolute top-6 right-6 z-30 px-5 py-2.5 rounded-xl bg-purple-600 hover:bg-purple-700 text-white flex items-center gap-2 text-sm font-medium shadow-lg transition-all"
        >
          {isEditing ? (
            <>
              <FaSave className="text-lg" /> Save Changes
            </>
          ) : (
            <>
              <FaEdit className="text-lg" /> Edit CV
            </>
          )}
        </button>

        {/* Header Bar */}
        <div className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white p-5 sm:p-6">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <h1 className="text-xl sm:text-2xl font-bold">e-Job CV</h1>
              {/* <button className="px-4 py-2 bg-white/20 hover:bg-white/30 rounded-lg backdrop-blur-sm flex items-center gap-2 transition-colors text-sm whitespace-nowrap">
                <FaCheckCircle className="text-green-300" />
                e-verify log
              </button> */}
            </div>
            <div className="text-left sm:text-right">
              <p className="text-white/80 text-sm">Date Generated</p>
              <div className="flex items-center gap-2">
                <FaCalendar className="text-white/60" />
                <span>{currentDate}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row">
          
          {/* Sidebar */}
          <div className="w-full lg:w-1/3 bg-gradient-to-b from-purple-700 to-indigo-800 text-white min-h-[calc(297mm-4rem)] p-6 sm:p-8 lg:min-h-auto">
            <div className="sticky top-8">
              <div className="mb-8">
                <h2 className="text-2xl font-bold mb-4 leading-tight">
                  {isEditing ? (
                    <div className="flex flex-col gap-2">
                      <input
                        type="text"
                        value={editableData.personalInfo.firstName}
                        onChange={(e) => handlePersonalChange('firstName', e.target.value)}
                        className="bg-transparent border-b-2 border-purple-300 focus:border-white outline-none text-2xl font-bold w-full"
                        placeholder="First Name"
                      />
                      <input
                        type="text"
                        value={editableData.personalInfo.lastName}
                        onChange={(e) => handlePersonalChange('lastName', e.target.value)}
                        className="bg-transparent border-b-2 border-purple-300 focus:border-white outline-none text-2xl font-bold w-full"
                        placeholder="Last Name"
                      />
                    </div>
                  ) : (
                    `${editableData.personalInfo.firstName} ${editableData.personalInfo.lastName}`
                  )}
                </h2>
                <p className="text-purple-200 text-sm">Professional Profile</p>
              </div>

              <div className="space-y-6">
                <div className="border-l-2 border-purple-400 pl-4">
                  <CvInfo 
                    third={true} 
                    title="Date of Birth" 
                    data={isEditing ? (
                      <input
                        type="text"
                        value={editableData.personalInfo.dateOfBirth}
                        onChange={(e) => handlePersonalChange('dateOfBirth', e.target.value)}
                        className="bg-transparent border-b border-purple-300 focus:border-white outline-none w-full py-1 text-purple-100"
                      />
                    ) : editableData.personalInfo.dateOfBirth}
                    className="text-purple-100" 
                  />
                </div>
                <div className="border-l-2 border-purple-400 pl-4">
                  <CvInfo 
                    third={true} 
                    title="Email" 
                    data={isEditing ? (
                      <input
                        type="email"
                        value={editableData.personalInfo.email}
                        onChange={(e) => handlePersonalChange('email', e.target.value)}
                        className="bg-transparent border-b border-purple-300 focus:border-white outline-none w-full py-1 text-purple-100"
                      />
                    ) : editableData.personalInfo.email}
                    className="text-purple-100"
                  />
                </div>
                <div className="border-l-2 border-purple-400 pl-4">
                  <CvInfo 
                    third={true} 
                    title="Address" 
                    data={isEditing ? (
                      <input
                        type="text"
                        value={editableData.personalInfo.address}
                        onChange={(e) => handlePersonalChange('address', e.target.value)}
                        className="bg-transparent border-b border-purple-300 focus:border-white outline-none w-full py-1 text-purple-100"
                      />
                    ) : editableData.personalInfo.address}
                    className="text-purple-100"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="flex-1 p-6 sm:p-8 bg-white shadow-xl">
            
            {/* Education Section */}
            <section className="mb-10">
              <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-6 border-b-2 border-purple-200 pb-2">
                Education Background
              </h3>
              <div className="space-y-4">
                {editableData.education.map((eachEducation, index) => (
                  <CvEducation
                    key={index}
                    school={isEditing ? (
                      <input
                        type="text"
                        value={eachEducation.school || ''}
                        onChange={(e) => handleArrayChange('education', index, 'school', e.target.value)}
                        className="w-full bg-white border border-gray-300 rounded px-4 py-2 focus:outline-none focus:border-purple-500"
                      />
                    ) : eachEducation.school}
                    course={isEditing ? (
                      <input
                        type="text"
                        value={eachEducation.course || ''}
                        onChange={(e) => handleArrayChange('education', index, 'course', e.target.value)}
                        className="w-full bg-white border border-gray-300 rounded px-4 py-2 focus:outline-none focus:border-purple-500"
                      />
                    ) : eachEducation.course}
                    year={isEditing ? (
                      <input
                        type="text"
                        value={`${eachEducation.startYear || ''} - ${eachEducation.finishYear || ''}`}
                        onChange={(e) => {
                          const [start, finish] = e.target.value.split('-').map(s => s.trim());
                          handleArrayChange('education', index, 'startYear', start || '');
                          handleArrayChange('education', index, 'finishYear', finish || '');
                        }}
                        className="w-full bg-white border border-gray-300 rounded px-4 py-2 focus:outline-none focus:border-purple-500"
                      />
                    ) : `${eachEducation.startYear} - ${eachEducation.finishYear}`}
                  />
                ))}
              </div>
            </section>

            {/* Work Experience Section */}
            <section className="mb-10">
              <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-6 border-b-2 border-purple-200 pb-2">
                Work Experience
              </h3>
              <div className="space-y-6">
                {editableData.experience.map((eachExperience, index) => (
                  <CvWorkExperience
                    key={index}
                    title={isEditing ? (
                      <input
                        type="text"
                        value={eachExperience.positionHeld || ''}
                        onChange={(e) => handleArrayChange('experience', index, 'positionHeld', e.target.value)}
                        className="w-full bg-white border border-gray-300 rounded px-4 py-2 focus:outline-none focus:border-purple-500"
                      />
                    ) : eachExperience.positionHeld}
                    companyName={isEditing ? (
                      <input
                        type="text"
                        value={eachExperience.companyName || ''}
                        onChange={(e) => handleArrayChange('experience', index, 'companyName', e.target.value)}
                        className="w-full bg-white border border-gray-300 rounded px-4 py-2 focus:outline-none focus:border-purple-500"
                      />
                    ) : eachExperience.companyName}
                    year={isEditing ? (
                      <input
                        type="text"
                        value={`${eachExperience.startYear || ''} - ${eachExperience.finishYear || ''}`}
                        onChange={(e) => {
                          const [start, finish] = e.target.value.split('-').map(s => s.trim());
                          handleArrayChange('experience', index, 'startYear', start || '');
                          handleArrayChange('experience', index, 'finishYear', finish || '');
                        }}
                        className="w-full bg-white border border-gray-300 rounded px-4 py-2 focus:outline-none focus:border-purple-500"
                      />
                    ) : `${eachExperience.startYear} - ${eachExperience.finishYear}`}
                    jobDescription={isEditing ? (
                      <textarea
                        value={eachExperience.jobDescription || ''}
                        onChange={(e) => handleArrayChange('experience', index, 'jobDescription', e.target.value)}
                        className="w-full bg-white border border-gray-300 rounded px-4 py-3 min-h-[90px] resize-y focus:outline-none focus:border-purple-500"
                      />
                    ) : eachExperience.jobDescription}
                  />
                ))}
              </div>
            </section>

            {/* Certificates Section */}
            <section className="mb-10">
              <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-6 border-b-2 border-purple-200 pb-2">
                Certificates
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {editableData.certificate.map((eachCertificate, index) => (
                  <CvCertificate
                    key={index}
                    title={isEditing ? (
                      <input
                        type="text"
                        value={eachCertificate.certificateName || ''}
                        onChange={(e) => handleArrayChange('certificate', index, 'certificateName', e.target.value)}
                        className="w-full bg-white border border-gray-300 rounded px-4 py-2 focus:outline-none focus:border-purple-500"
                      />
                    ) : eachCertificate.certificateName}
                    year={isEditing ? (
                      <input
                        type="text"
                        value={eachCertificate.issueDate || ''}
                        onChange={(e) => handleArrayChange('certificate', index, 'issueDate', e.target.value)}
                        className="w-full bg-white border border-gray-300 rounded px-4 py-2 focus:outline-none focus:border-purple-500"
                      />
                    ) : eachCertificate.issueDate}
                    serialNumber={isEditing ? (
                      <input
                        type="text"
                        value={eachCertificate.serialNumber || ''}
                        onChange={(e) => handleArrayChange('certificate', index, 'serialNumber', e.target.value)}
                        className="w-full bg-white border border-gray-300 rounded px-4 py-2 focus:outline-none focus:border-purple-500"
                      />
                    ) : eachCertificate.serialNumber}
                  />
                ))}
              </div>
            </section>

            {/* Guarantor Section */}
            <section className="mb-10">
              <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-6 border-b-2 border-purple-200 pb-2">
                Guarantor
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {editableData.guarantor.map((eachGuarantor, index) => (
                  <CvGuarantor
                    key={index}
                    guarantorName={isEditing ? (
                      <input
                        type="text"
                        value={eachGuarantor.name || ''}
                        onChange={(e) => handleArrayChange('guarantor', index, 'name', e.target.value)}
                        className="w-full bg-white border border-gray-300 rounded px-4 py-2 focus:outline-none focus:border-purple-500"
                      />
                    ) : eachGuarantor.name}
                    phoneNumber={isEditing ? (
                      <input
                        type="text"
                        value={eachGuarantor.phone || ''}
                        onChange={(e) => handleArrayChange('guarantor', index, 'phone', e.target.value)}
                        className="w-full bg-white border border-gray-300 rounded px-4 py-2 focus:outline-none focus:border-purple-500"
                      />
                    ) : eachGuarantor.phone}
                  />
                ))}
              </div>
            </section>
          </div>
        </div>
      </div>
    </PDFGenerator>
  );
}

export default CvTemplate3;